import { BaseLayerElement } from './layer.js';

export class HTMLLayerElement extends BaseLayerElement {
  constructor() {
    super();
    // specific behavior for <map-layer>
  }
}
